import React, { useContext, useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import ConferenceRoomHdr from './components/conferenceRoomHdr';
import ConferenceRoomBdy from './components/conferenceRoomBdy';
import { Button } from '@mui/material';
import CRoomMainCrnt from './components/conferenceRoomMainContainer';
import DesktopFooter from '../Deskfooter';
import { ToastContainer, toast } from 'react-toastify';
import ControllerContext from '../../../../RoomControllerSocketContext';
import ConnectYourRoom from '../ConnectYourRoom';
import callApi from '../../libs/callApi';

const ConferenceRoom = () =>
{
	const [ refresh, setRefresh ] = useState(false);
	const { pluginSocket, isOnline } = useContext(ControllerContext);
	const [ roomName, setRoomName ] = useState('');
	const roomDataSignal = useRef(null);
	const navigate = useHistory();

	useEffect(() =>
	{
		pluginSocket?.on('unpair', async (data) =>
		{
			const unpairStatus = await window?.electron?.ipcRenderer?.invoke('unpair');

			if (unpairStatus)
			{
				toast.dismiss();
				toast.error('Controller Unpaired!');
				pluginSocket.emit('leaveRoom');
				setTimeout(() =>
				{
					navigate.push('/');
				}, 2000);
			}
		});
		pluginSocket?.on('disconnectingroom', async (data) =>
		{
			window?.electron?.ipcRenderer.invoke('disconnectingroom', { key: 'roomName' });
			window?.electron?.ipcRenderer.invoke('disconnectingroom', { key: 'roomId' });

			toast.dismiss();
			toast.error('Room disconnected!');

			setTimeout(() =>
			{
				navigate.push('/controllerPair');
			}, 2000);

		});

		pluginSocket?.on('refreshPage', (data) =>
		{
			console.log('refreshpage', data);
			setRefresh((preState) => !preState);
		});

		return () =>
		{
			pluginSocket?.off('unpair');
			pluginSocket?.off('disconnectingroom');
			pluginSocket?.off('refreshPage');
		};
	}, [ pluginSocket ]);

	useEffect(() =>
	{
		async function getRoomNameData()
		{
			const roomNameData = await window?.electron?.ipcRenderer?.invoke('getRoomData', 'roomName');

			if (roomNameData)
			{
				setRoomName(roomNameData);
			}
		}
		getRoomNameData();

	}, []);

	useEffect(() =>
	{
		async function getRoomData()
		{
			const roomIdData = await window?.electron?.ipcRenderer?.invoke('getRoomData', 'roomId');
			const machineId = await window?.electron?.ipcRenderer?.invoke('getMachineId');

			if (roomIdData)
			{
				const dataforRoomPlugin = JSON.stringify({
					'path'   : `/plugins/getroom/${roomIdData}/desktop/${machineId}`,
					'method' : 'GET'
				});

				try
				{
					if (roomDataSignal.current)
					{
						roomDataSignal.current.abort();
					}

					roomDataSignal.current = new AbortController();

					const RoomResponse = await callApi(dataforRoomPlugin, roomDataSignal.current.signal);

					console.log('????????????????????', RoomResponse);
					roomDataSignal.current = null;
					if ((RoomResponse?.status === false && RoomResponse?.message === 'ROOM_NOT_EXISTS'))
					{
						const unpairStatus = await window?.electron?.ipcRenderer?.invoke('unpair');

						if (unpairStatus)
						{
							toast.dismiss();
							toast.error(RoomResponse.error);
							setTimeout(() =>
							{
								navigate.push('/');
							}, 2000);
						}
					}
					else
					if (RoomResponse?.data?.roomName)
					{
						setRoomName(RoomResponse?.data?.roomName);
						window?.electron?.ipcRenderer.sendMessage('storeData', { key: 'roomName', value: RoomResponse?.data?.roomName });
					}
				}
				catch (error)
				{
					console.log(error);
					roomDataSignal.current = null;
				}
			}

		}
		getRoomData();

	}, [ refresh ]);

	return (
		<>
			<div className='flexCol fullH desktopbgimage pdngLG desktopContentSelect'>
				<div className='flexRow'>
					<ConferenceRoomHdr isOnline={isOnline} setRefresh={setRefresh} roomName={roomName}/>
				</div>
				<div className='flexMinHeightCol pdngTMD aCntr jCntr'>
					<CRoomMainCrnt refresh={refresh}/>
				</div>
				<div className='flexAutoCol'>
					<DesktopFooter />
				</div>
			</div>
			<ToastContainer
				position='top-center'
				autoClose={2000}
				hideProgressBar={false}
				newestOnTop={false}
				closeOnClick
				rtl={false}
				pauseOnFocusLoss
				draggable
				pauseOnHover
				theme='light'
			/>
		</>
	);
};

export default ConferenceRoom;
